var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIsrael(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h30v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1433b3",
    d: "M0 4h30v4H0zm0 12h30v4H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1437b0",
    d: "m15 15.46-1-1.73h-2L13 12l-1-1.73h2l1-1.73 1 1.73h2L17 12l1 1.73h-2zm-.37-1.73.37.63.37-.63zm1.69-.55h.73l-.37-.63zm-2 0h1.36l.68-1.18-.68-1.18h-1.36L13.63 12zm-1.37 0h.73l-.36-.63zm3.37-2.36.36.63.37-.63zm-3.37 0 .37.63.36-.63zm1.68-.55h.73L15 9.64z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsrael);
export default __webpack_public_path__ + "static/media/israel.7639c8d9621a039d11436bec0c3bda5d.svg";
export { ForwardRef as ReactComponent };